<template>
    <version-modal-form v-if="!isProcessing" :api-route="'quiz'" :model="type" @version="version" @close="close">
        <template #preview>
            <p>
                To view the current version of the {{ type }} click
                <e-tag class="clickable is-clickable" type="is-link is-light" @click="preview()">Preview</e-tag>
            </p>
        </template>
    </version-modal-form>
    <div v-else class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">Creating New Version</p>
        </header>
        <section class="modal-card-body">
            <div class="has-text-centered">
                <e-loading :is-full-page="false" active />
                <e-progress type="is-primary" size="is-small" />
                <p v-if="error" class="has-text-danger mt-2">{{ error }}</p>
            </div>
        </section>
        <footer class="modal-card-foot tw:flex tw:gap-2">
            <e-button v-if="error" type="is-primary" @click="retryVersion">Retry</e-button>
            <e-button v-if="error" @click="close">Cancel</e-button>
        </footer>
    </div>
</template>

<script>
import VersionModalForm from '@/components/version/VersionModalForm.vue';

import axios from '@/plugins/axios.js';

export default {
    name: 'QuizVersionModalForm',
    components: { VersionModalForm },

    props: {
        quiz: {
            type: Object,
            required: true,
        },
    },

    emits: ['close', 'preview'],

    data() {
        return {
            isProcessing: false,
            error: null,
            channel: null,
        };
    },

    computed: {
        type() {
            return this.quiz.type ? this.quiz.type : 'quiz';
        },
    },

    async mounted() {
        await this.initializeEchoListener();
    },

    beforeUnmount() {
        this.removeEchoListener();
    },

    methods: {
        async initializeEchoListener() {
            this.channel = this.$echo
                .private(`quiz.version.${this.quiz.id}`)
                .listen('QuizVersionCompleted', event => this.handleVersionComplete(event));
        },

        removeEchoListener() {
            if (this.channel) {
                this.channel.stopListening('QuizVersionCompleted');
            }
        },

        async version() {
            this.isProcessing = true;
            this.error = null;

            try {
                await axios.post(`/api/version-quiz/${this.quiz.id}`);
            } catch (error) {
                this.error = 'Failed to create quiz version. Please try again.';
                console.error('Quiz versioning error:', error);
            }
        },

        handleVersionComplete(event) {
            window.location.replace(`/quizzes/${event.new_version_id}`);
        },

        async retryVersion() {
            this.error = null;
            await this.version();
        },

        async close() {
            if (this.$route.name === 'quiz-view') {
                this.$router.push({ name: 'quizzes-index' });
            } else if (this.$route.name === 'survey-view') {
                this.$router.push({ name: 'surveys-index' });
            } else {
                window.location.reload();
            }

            this.$emit('close');
        },

        async preview() {
            this.$emit('close');
            this.$emit('preview');
        },
    },
};
</script>

<style scoped>
.modal-card {
    margin: 0 auto;
    max-width: 500px;
}
</style>
